import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { OnlineShopping } from './OnlineShopping.types';

export function useOnlineShoppingData(): Page<OnlineShopping>['templateFields'] {
  return useCurrentPage<Page<OnlineShopping>>().templateFields;
}
